import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-sms-share-record",
  "use": "icon-sms-share-record-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" id=\"icon-sms-share-record\"><path d=\"M257.536 703.36s56.96-176.64 198.656-272.384C597.888 335.232 715.648 360.96 715.648 360.96l-1.92 95.616 235.52-187.648L715.776 84.992v101.12s-171.264-27.52-305.408 106.752C260.096 443.392 257.536 703.36 257.536 703.36z\" p-id=\"2470\" /><path d=\"M920.32 493.056c-17.664 0-32 14.336-32 32v376.32H135.68v-752.64h376.32c17.664 0 32-14.336 32-32s-14.336-32-32-32H120.576C93.568 84.736 71.68 106.624 71.68 133.632V916.48c0 27.008 21.888 48.896 48.896 48.896h782.848c27.008 0 48.896-21.888 48.896-48.896V525.056c0-17.664-14.336-32-32-32z\" p-id=\"2471\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/sms-share-record.svg
// module id = 39pV
// module chunks = 34